import React from 'react';
import FeatureSummary from '../../../Util/FeatureSummary';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../Table/DetailsTable';

const EmlSendersTable = ({
    emlSenders,
    loading,
    editOnClick,
    createOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu editOnClick={editOnClick} id={item.emlSenderID} />
            ),
        },
        {
            name: 'ID',
            fieldName: 'emlSenderID',
            minWidth: 50,
            maxWidth: 60,
            isResizable: true,
        },
        {
            name: 'From Name',
            fieldName: 'fromName',
            minWidth: 120,
            maxWidth: 180,
            isResizable: true,
            isSorted: true,
            isSortedDescending: false,
        },
        {
            name: 'From Email',
            fieldName: 'fromEmailAddress',
            minWidth: 150,
            maxWidth: 250,
            isResizable: true,
        },
        {
            name: 'Reply To',
            fieldName: 'replyToEmail',
            minWidth: 150,
            maxWidth: 250,
            isResizable: true,
        },
        {
            name: 'Street Address',
            fieldName: 'streetAddress1',
            minWidth: 120,
            maxWidth: 200,
            isResizable: true,
        },
        {
            name: 'City',
            fieldName: 'city',
            minWidth: 80,
            maxWidth: 120,
            isResizable: true,
        },
        {
            name: 'State',
            fieldName: 'state',
            minWidth: 50,
            maxWidth: 80,
            isResizable: true,
        },
        {
            name: 'Zip Code',
            fieldName: 'zipCode',
            minWidth: 60,
            maxWidth: 90,
            isResizable: true,
        },
    ];

    const items = emlSenders ?? [];

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionMode="none"
                loading={loading}
                mainColumn={'fromName'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: 'Add' }}
                        text="Add Email Sender"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                summary="This table displays all configured email senders including the from name, email addresses, and physical mailing address. You can add new senders or edit existing ones."
                label="About Email Senders"
            />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, id, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'edit',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default EmlSendersTable;
